var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommitment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm-.608-11.23c-.55-.37-1.017-.544-1.403-.52-1.375.084-2.489 1.02-2.489 2.465-.002 2.27 2.93 3.444 4.757 4.161.168.065 1.615.546 1.601.624.231-1.394.661-2.793 1.306-4.065.509-1.007 1.482-2.03 1.318-3.221-.153-1.098-1.253-1.682-2.284-1.713-.941-.027-1.877.73-2.806 2.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitment);
export default __webpack_public_path__ + "static/media/commitment.ed664899ed5b67c0ce8c4f732b9ebe94.svg";
export { ForwardRef as ReactComponent };